import React from 'react';

export const CheckoutSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-center items-center">
          <div className="h-8 w-24 bg-gray-300 rounded"></div>
        </div>
        <div className="border-t border-gray-200"></div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div className="bg-white shadow rounded-2xl p-6 space-y-4">
              <div className="h-5 w-40 bg-gray-300 rounded"></div>
              <div className="h-10 w-full bg-gray-200 rounded"></div>
              <div className="h-10 w-full bg-gray-200 rounded"></div>
            </div>

            <div className="bg-white shadow rounded-2xl p-6 space-y-4">
              <div className="h-5 w-40 bg-gray-300 rounded"></div>
              <div className="h-10 w-full bg-gray-200 rounded"></div>
              <div className="h-10 w-full bg-gray-200 rounded"></div>
              <div className="grid grid-cols-3 gap-4">
                <div className="h-10 w-full bg-gray-200 rounded"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
                <div className="h-10 w-full bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>

          <div className="bg-white shadow rounded-2xl p-6 space-y-4">
            <div className="h-14 w-14 bg-gray-300 rounded"></div>
            <ul className="divide-y divide-gray-200">
              <li className="flex justify-between py-4">
                <div className="space-y-2">
                  <div className="h-4 w-32 bg-gray-200 rounded"></div>
                  <div className="h-3 w-20 bg-gray-200 rounded"></div>
                </div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
              </li>
              <li className="flex justify-between py-4">
                <div className="space-y-2">
                  <div className="h-4 w-32 bg-gray-200 rounded"></div>
                  <div className="h-3 w-20 bg-gray-200 rounded"></div>
                </div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
              </li>
            </ul>
            <div className="border-t border-gray-200 mt-4 pt-4 flex justify-between">
              <div className="h-4 w-16 bg-gray-200 rounded"></div>
              <div className="h-4 w-20 bg-gray-200 rounded"></div>
            </div>
            <div className="flex gap-4">
              <div className="h-10 w-full bg-gray-300 rounded-lg mt-6"></div>
              <div className="w-20 h-10 bg-gray-300 rounded-lg mt-6"></div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};
